<template>
  <div>
    <l-editor disabled  :isUploadImg="false"  v-if="data.type == 'texteditor'" :height="data.height" v-model="data.default"  :placeholder="data.placeholder"  >
    </l-editor>
    <l-count
      v-else-if="['count'].includes(data.type)" 
      v-model="data.default"
      :formatJson="data.formatJson"
      :formData="allFormData"
      :decimal="data.decimal"
      :thousandSeparator="data.thousandSeparator"
      :isChinese="data.isChinese">
    </l-count>
    <div style="height: 80vh;" id="query_box" v-else-if="['customTable'].includes(data.type)">
      <l-query-search v-if="data.showSearch" :buttomList="fliterBtns" :ParamJsonList="data.ParamJsonList" :configData="data" @getList="getList" :showReset="false" :viewMode="false" ref="customSearch" :searchText="'查询'"></l-query-search>
      <div id="table_btn" :style="{'height':data.showSearch ? 'calc(100% - 66px)': '100%'}">
        <l-customTable ref="customTable" :headerData="headerData" :buttomList="fliterInBtns" :tableData="tableData" />
      </div>
    </div>
    <component v-else :is="getComponent(data.type)"
                v-model="data.default"
                v-bind="$deepClone(data)"
                :placeholder="data.placeholder"
                :options="myOptions"
                :isNotUpLoad="true"
               >
        <span v-if="data.html" :style="data.type == 'divider' ? { 'font-size': data.fontSize + 'px','color': data.color} : {}"
            v-html="data.html"></span>
        <template v-if="['input'].includes(data.type) && data.prepend" #prepend >
            {{data.prepend}}
        </template>
        <template v-if="['input'].includes(data.type) && data.append" #append >
            {{data.append}}
        </template>
    </component>
  </div>
</template>
<script>
// const api = window.$api.data.dbsource
const dbsourceApi = () => {
  return window.$api.data.dbsource
};
import mixin from '../../mixin'
export default {
    name: 'drag-form-item',
    mixins: [mixin()],
    inject: ["formDesign"],
    props: {
        data: {
            type: Object,
            default: () => {
            return {}
            }
        },
        allFormData: {
            type: Object,
            default: () => {
                return {};
            },
        }
    },
    computed: {
        fliterBtns(){
            if(!this.data.btns){
                return []
            }
            return this.data.btns.filter(x => !x.isRowBtn) || []
        },
        fliterInBtns(){
            if(!this.data.btns){
                return []
            }
            return this.data.btns.filter(x => x.isRowBtn) || []
        },
    },
    watch: {
        'data.ParamJsonList': {
            handler(newValue) {
                console.log('data对象发生变化');
                console.log(newValue,'data对象发生变化');
                // 你可以在这里处理user对象任何层级属性的变化
                this.getOption()
            },
            deep: true // 开启深度监听
        }
    },
    data () {
        return {
            headerData:[],
            tableData:[],
            loading:false
        }
    },
    mounted() {

    },
    methods: {
        toValueType(type,value){
            if(!this.$validatenull(value) && !this.$validatenull(type)){
                switch(type){
                    case 'boolean':
                        return value == 'true'
                    case 'string':
                        return value
                    case 'number':
                        return Number(value)
                }
            }
        },
        async getOption() {
            console.log(this.data);
            var queryArr = JSON.parse(this.data.ParamJsonList)
            if(queryArr.length){
                var obj = {}
                
                queryArr.forEach(item => {
                var bol = true
                for(var i in this.lr_dataParamsSource){
                    if(i == item.f_DefaultValue){
                        obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                        bol= false
                    }else{
                    if(bol){
                        if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                        obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                        }else{
                        obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                        }
                    }
                    }
                }
                // obj[item.f_ParamName.slice(1)] = item.f_DefaultValue ? item.f_DefaultValue : item.f_NewDefaultValue ? item.f_NewDefaultValue : ''
                })
                var pamdata = {
                queryJson:obj
                }
                let res = await dbsourceApi().newGetDataListByParamter(this.data.dataCode,pamdata)
                this.tableData = res.data.data
                this.headerData = this.data.fieldOptions
                this.$nextTick(() => {
                    this.$refs.customTable.processData()
                })
            }
        },
    }
}
</script>
<style scoped lang="less">
::v-deep {
    .el-divider .el-divider__text {
        color: unset ;
    }
}
</style>